import {
  ESCROW_SHORTAGE_FEE_AMOUNT_REQUIRED_MESSAGE,
  PAYMENTS_ONLINE_AMOUNT_CHARGED_FOR_ESCROW_SHORTAGE_KEY,
  PAYMENTS_ONLINE_CHARGE_ESCROW_SHORTAGE_ONLINE_KEY,
} from "../constants/Configurator.constants";

// Local mock mode short-circuits the config API to fixtures, so a publish never
// reaches a server and nothing can legitimately be reported as failed.
export const isLocalMockMode = () =>
  process.env.REACT_APP_API_INTEGRATION === "0" &&
  (!process.env.NODE_ENV || process.env.NODE_ENV === "development");

// Settings that are only coherent in combination are checked here, before the batch
// write, because the batch write has no idea they are related: it saves each key on
// its own and reports success for both halves of a broken pair.
//
// Only the escrow shortage fee qualifies so far. Charging it with no amount stored
// makes the payments service throw on every escrow shortage quote and payment, and
// storing zero turns the fee off without saying so. Neither is anything an admin
// means to publish.
//
// Judged only when one of the two keys is actually in the publish. Publishing is
// global across every configuration category, so refusing on the stored state alone
// would stop an admin editing branding until somebody else repaired a payments
// setting they had not touched and could not see. The values are still read from the
// whole configuration rather than the modified subset, so turning the fee on against
// an amount stored earlier is recognised as complete.
export const findEscrowShortageFeeError = (edittedFields = []) => {
  const fieldFor = (key) => edittedFields.find((item) => item?.key === key);

  const charge = fieldFor(PAYMENTS_ONLINE_CHARGE_ESCROW_SHORTAGE_ONLINE_KEY);
  const amount = fieldFor(PAYMENTS_ONLINE_AMOUNT_CHARGED_FOR_ESCROW_SHORTAGE_KEY);

  if (!charge?.modified && !amount?.modified) {
    return null;
  }

  if (String(charge?.value) !== "true") {
    return null;
  }

  const value = amount?.value;

  return value === undefined || value === null || value === "" || +value <= 0
    ? ESCROW_SHORTAGE_FEE_AMOUNT_REQUIRED_MESSAGE
    : null;
};

// The batch write answers with one entry per property. A property is only saved if
// its entry comes back 200. Anything else means it never reached the database: a
// non-200 status, a response that is not a list at all (the API layer resolves
// undefined when a request is rejected), or a requested key the response omits.
export const collectFailedPublishKeys = (writeResponse, requestBody = []) => {
  const failedKeys = new Set();
  const requestedKeys = requestBody
    .map((item) => item?.property?.key)
    .filter(Boolean);

  if (!Array.isArray(writeResponse)) {
    requestedKeys.forEach((key) => failedKeys.add(key));
    return failedKeys;
  }

  const statusByKey = new Map();
  writeResponse.forEach((item, index) => {
    const key = item?.property?.key ?? requestBody[index]?.property?.key;
    if (key) {
      statusByKey.set(key, +item?.httpStatus);
    }
  });

  requestedKeys.forEach((key) => {
    if (statusByKey.get(key) !== 200) {
      failedKeys.add(key);
    }
  });

  return failedKeys;
};
